<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的备案</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">我的备案</div>
      </div>
      <div class="panel-body clearfix">
        <!--列表-->
        <el-table :data="userList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="id" label="备案编号" align="center">
          </el-table-column>
          <el-table-column prop="ba_path" label="备案方式" align="center">
          </el-table-column>
          <el-table-column prop="zbdwmc" label="主办单位名称" min-width="200" align="center">
          </el-table-column>
          <el-table-column prop="fzr_xm" label="负责人姓名" align="center">
          </el-table-column>
          <el-table-column prop="ztbah" label="主体备案号" align="center">
          </el-table-column>
          <el-table-column prop="icp_lasttime" label="更新时间" align="center">
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
            <template slot-scope="scope">
              <span class="z-curPonit z-color-a">{{scope.row.state}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" align="center" width="100">
            <template slot-scope="scope">
              <router-link :to="'/icpContent'+'/'+scope.row.id" class="z-color-a">[详情]</router-link>
              &nbsp;&nbsp;
              <span v-if="scope.row.state === '准备任务'" class="z-curPonit" @click="ipcDel(scope.row.id)" style="color: #f90101">[删除]</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import beianService from 'business/beianService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        dialogLoading:false,
        userList: [],
        listLoading:false,
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      sessionStorage.removeItem('tabs')
      this.SearchBeian()
    },
    methods:{
      ...mapActions(['BEIANZT']),
      async SearchBeian() {
        this.listLoading = true
        let data = 'cmd=task_list'+'&count='+ this.count +'&page='+ this.page
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.userList = vueData.msg.content.map((item, index) => {
            return {
              id:item.id,
              ba_path:item.ba_path,
              zbdwmc:item.zbdwmc,
              fzr_xm:item.fzr_xm,
              ztbah:item.ztbah,
              icp_lasttime:item.icp_lastTime,
              state:item.zt,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchBeian()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchBeian()
      },
      async ipcDel(id) {
        MessageBox.confirm('确定要删除此备案任务吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=task_del'+
            '&taskid='+ id
          let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({
              type:'success',
              info: vueData.msg,
              click () {
                self.SearchBeian()
              }
            })
          }else {
            this.dialogLoading = false
            this.$dialog({
              type:'error',
              info: vueData.msg,
              click () {}
            })
          }
        }).catch(() => {

        });

      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
</style>



// WEBPACK FOOTER //
// src/pages/beian/icpMain.vue